// extracted by mini-css-extract-plugin
export default {"mCard":"UD-z","image":"VD-z","imageNoBackground":"WD-z","imageHasCategory":"XD-z","fullWidth":"YD-z"};